import { render } from "./BoardCalendarView.vue?vue&type=template&id=12f2ed52&scoped=true"
import script from "./BoardCalendarView.vue?vue&type=script&lang=js"
export * from "./BoardCalendarView.vue?vue&type=script&lang=js"

import "./BoardCalendarView.vue?vue&type=style&index=0&id=12f2ed52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12f2ed52"

export default script